/**
 * Copyright (c) OpenSpug Organization. https://github.com/openspug/spug
 * Copyright (c) <spug.dev@gmail.com>
 * Released under the MIT License.
 */
import React from 'react';
import {Button, Result} from 'antd';
import history from 'libs/history';


class StudentResult extends React.Component {

  render() {
    return (
      <div >
        <Result
          status="success"
          title="信息提交成功"
          extra={[
            <Button type="primary" key="success" onClick={()=> history.push('/add_student')}>
              返回首页
            </Button>,
          ]}
        />,
      </div>
    )
  }
}

export default StudentResult
